import * as React from "react";
import { FormatMessage as FormatMessageComponent } from "react-globalize";
import Reminders from "components/product-media/components/reminders";
import { ASSORTMENTS } from "constants/integration/assortments";

interface IProps {
    items: string[];
    wasUpdated: boolean;
}

export const SummarizeDoorsWithUnitsEnabled: React.FC<IProps> = ({ items, wasUpdated }) => {
    const title = wasUpdated ? (
        <FormatMessageComponent
            path="[strong]Doors[strong] turned [strong]on[strong] that contain units:"
            elements={{ strong: <b /> }}
        />
    ) : (
        <FormatMessageComponent
            path="[strong]Doors[strong] to be turned [strong]on[strong] that contain units:"
            elements={{ strong: <b /> }}
        />
    );
    return (
        <Reminders
            title={title}
            shouldUseCurrentColor
            dataTestList={ASSORTMENTS.ALLOCATION_DIMENSIONS.IMPORT_DOOR_GROUPINGS.SUMMARIZE_COLUMN.DOOR_WITH_UNITS.LIST}
            dataTestTitle={
                ASSORTMENTS.ALLOCATION_DIMENSIONS.IMPORT_DOOR_GROUPINGS.SUMMARIZE_COLUMN.DOOR_WITH_UNITS.TITLE
            }
        >
            {items.map((col, index) => (
                <li
                    key={`${col}-${index}`}
                    data-test={`${ASSORTMENTS.ALLOCATION_DIMENSIONS.IMPORT_DOOR_GROUPINGS.SUMMARIZE_COLUMN.DOOR_WITH_UNITS.ITEM}-${index}`}
                >
                    {col}
                </li>
            ))}
        </Reminders>
    );
};
